import { put } from 'redux-saga/effects';
import {
    updateDashboard,
    updatePropertyData,
    updateBilling,
    setPropertyManagerError,
} from '../reducers/propertyManager';

export function* handleGetDashboardData(action) {
    try {
        const response = yield fetch(process.env.REACT_APP_PM_DASHBOARD, {
            method: 'GET',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
        });
        const data = yield response.json();
        if (!response.ok) throw Error(data.message);
        yield put(updateDashboard(data));
    } catch (e) {
        yield put(setPropertyManagerError({ error: e.toString() }));
    }
    yield action?.payload?.setLoading?.(false);
}

export function* handleGetPropertyData(action) {
    try {
        let url = process.env.REACT_APP_PM_PROPERTYData;
        url = url.replace( "{propertyId}", action.payload.propertyId)
        const response = yield fetch( url, {
            method: 'GET',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
        });
        const data = yield response.json();
        if (!response.ok) throw Error(data.message);
        yield put(updatePropertyData(data));
    } catch (e) {
        yield put(setPropertyManagerError({ error: e.toString() }));
    }
    yield action?.payload?.setLoading?.(false);
}

export function* handleGetBillingData(action) {
    try {
        const response = yield fetch(process.env.REACT_APP_PM_BILLING, {
            method: 'GET',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
        });
        const data = yield response.json();
        if (!response.ok) throw Error(data.message);
        yield put(updateBilling(data));
    } catch (e) {
        yield put(setPropertyManagerError({ error: e.toString() }));
    }
    yield action?.payload?.setLoading?.(false);
}
